import Swiper, { Navigation, Autoplay, Keyboard } from 'swiper';
import { updatePagination } from "./slider-functions";

Swiper.use([Navigation, Autoplay, Keyboard]);

export default function (el) {
    const swiperEl = el.querySelector(".swiper");
    const slidesCount = el.querySelectorAll(".swiper-slide").length;
    const paginationEl = el.querySelector(".swiper-controls__pagination");
    let swiper;
    let config = {};
    
    if(!swiperEl || slidesCount < 2) return;

    if(el.dataset.config) {
        try {
            config = JSON.parse(el.dataset.config);
        } catch {}
    }

    swiper = new Swiper(swiperEl, {
        spaceBetween: 24,
        slidesPerView: "auto",
        grabCursor: true,
        navigation: {
            nextEl: el.querySelector('.swiper-controls__button--next'),
            prevEl: el.querySelector('.swiper-controls__button--prev'),
        },
        ...config,
        on: {
            init: (swiper) => {
                updatePagination(swiper, paginationEl, slidesCount)
            },
            slideChange: (swiper) => {
                updatePagination(swiper, paginationEl, slidesCount)
            },
        }
    });

    return swiper;
}